import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText } from "lucide-react";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/logs").then((r) => setLogs(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="admin-logs">
      <div>
        <h1 className="font-heading font-black text-3xl tracking-tight text-sapphire">System Logs</h1>
        <p className="text-muted-foreground text-sm mt-1">Audit trail of platform events.</p>
      </div>
      <div className="border border-border rounded-md bg-white divide-y divide-border font-mono text-xs">
        {logs.length === 0 && <div className="p-8 text-center text-muted-foreground font-sans">No logs yet.</div>}
        {logs.map((l) => (
          <div key={l.id} className="flex items-start gap-3 px-4 py-2.5" data-testid={`log-${l.id}`}>
            <FileText className="w-3.5 h-3.5 text-ocean mt-0.5 flex-shrink-0" />
            <span className="text-muted-foreground whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</span>
            <span className="font-semibold text-sapphire">{l.action}</span>
            <span className="text-slate-500 truncate">{JSON.stringify(l.meta)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
